export const CONTACT = {
    email: "Ynovaedu@gmail.com",
    phoneDisplay: "+91 9898556879",
    whatsappUrl: "https://wa.me/919898556879",
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1623076189461-f7706b741c04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxjaGlsZCUyMG9ubGluZSUyMGxlYXJuaW5nJTIwbGFwdG9wfGVufDB8fHx8MTc5MDA5Nzg1Mnww&ixlib=rb-4.1.0&q=85&w=1200&h=1000&fit=crop",
    reading: "https://images.pexels.com/photos/3457273/pexels-photo-3457273.jpeg?auto=compress&cs=tinysrgb&w=900&h=675&fit=crop",
    writing: "https://images.unsplash.com/photo-1646617747593-8f075659286a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxjaGlsZCUyMHdyaXRpbmd8ZW58MHx8fHwxNzkxOTcxODYwfDA&ixlib=rb-4.1.0&q=85&w=900&h=675&fit=crop",
    online: "https://images.pexels.com/photos/5905886/pexels-photo-5905886.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
